import { INBOX_CHATS_PATH } from '../../constants';

/**
 * `/accounts/:accountId/assistants/:assistantId/inbox/chats` — the only place
 * the chats inbox is mounted (`AppRouter.tsx`). Anchored at both ends, so the
 * other inboxes (`/inbox/calls`, `/inbox/phone-calls`, `/inbox/agent-calls`)
 * and the legacy `/inbox` redirect never match; a plain substring test would
 * also catch an id that happens to contain the segment.
 */
const INBOX_CHATS_ROUTE = new RegExp(`^/accounts/[^/]+/assistants/[^/]+/${INBOX_CHATS_PATH}/?$`);

export function isInboxChatsPath(pathname: string): boolean {
  return INBOX_CHATS_ROUTE.test(pathname);
}
